{% block uc_theme_picker %}
<div class="uc-theme-picker">
    <div
        v-for="theme in themes"
        :key="theme.key"
        class="uc-theme-picker__card"
        :class="{ 'is-active': value === theme.key }"
        @click="select(theme.key)"
        role="radio"
        :aria-checked="value === theme.key"
        tabindex="0"
        @keydown.enter="select(theme.key)"
        @keydown.space.prevent="select(theme.key)"
    >
        {# Colour swatch strip #}
        <div class="uc-theme-picker__swatches">
            <span
                v-for="(color, i) in theme.preview"
                :key="i"
                class="uc-theme-picker__swatch"
                :style="{ background: color }"
            />
        </div>

        <div class="uc-theme-picker__info">
            <span class="uc-theme-picker__name">{{ label(theme.key) }}</span>
            <span class="uc-theme-picker__desc">{{ desc(theme.key) }}</span>
        </div>

        <span v-if="value === theme.key" class="uc-theme-picker__check">✓</span>
    </div>
</div>
{% endblock %}
